import { useTranslation } from 'react-i18next';

import { Section } from '@/components/content-layout/section';
import { SectionHeader } from '@/components/content-layout/section-header';
import { TBH } from '@/components/pages/tbh-page';

export function SalesPage() {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionHeader title={t('sales-page-title')} />
      <TBH />
    </Section>
  );
}
